/**
 * Created by neo on 25.02.17.
 */
import Config from '../../Config/index';
import { observable, action } from 'mobx';
import FlightOffer from './';
import BackendFactory from '../../Services/BackendFactory';

export class FlightOfferStore {
  @observable loading = false;
  @observable flightOffers: Array<FlightOffer> = [];

  @action async load(page?: number = 0, lang: string) {
    this.loading = true;
    if (!page || 0 >= page) {
      page = 0;
      this.flightOffers = [];
    }
    const backend = await BackendFactory();
    const res = await backend.get('/offer', { page, companyId: Config.companyId, lang });
    if (res.ok) {
      this.flightOffers = res.data.content.map(f => new FlightOffer(f));
    }
    this.loading = false;
  }

  @action async get(id: string, lang: string): Promise<FlightOffer> {
    const backend = await BackendFactory();
    const res = await backend.get(`/offer/${id}`, { lang });
    if (res.ok) {
      return new FlightOffer(res.data);
    }
    return null;
  }
}

const instance = new FlightOfferStore();
export default instance;



// WEBPACK FOOTER //
// ./src/App/Store/FlightOffer/Store.js